export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
  'component.exportResult.success': 'Export Complete ✓',
  'component.exportResult.processedCount': 'Processed: {count} records',
  'component.exportResult.filename': 'Filename: {filename}',
  'component.exportResult.fileSize': 'File Size: {size}',
  'component.exportResult.unknown': 'Unknown',
};
